import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'
// import ToBeAvailable from '@/views/ToBeAvailable.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    // component: ToBeAvailable,
    // meta: {
    //   title: 'Protein Sublocalization Localization Database'
    // }
  },

  {
    path: '/update-data-SR',
    name: 'update-data-SR',
    component: () => import(/* webpackChunkName: "about" */ '@/views/UpdateDate.vue'),
    meta: {
      title: 'Update Data'
    }
  },


  {
    path: '/data/single-protein',
    name: 'data-single-protein',
    component: () => import(/* webpackChunkName: "about" */ '@/views/DataSingleProtein.vue'),
    meta: {
      title: 'Protein Information | MELO'
    }
  },


  {
    path: '/data/protein-pair',
    name: 'data-protein-pair',
    component: () => import(/* webpackChunkName: "about" */ '@/views/DataProteinPairs.vue'),
    meta: {
      title: 'Protein Pair Information | MELO'
    }
  },
  

  {
    path: '/assessment',
    name: 'assessment',
    component: () => import(/* webpackChunkName: "about" */ '@/views/newViews/AssessmentPageNew.vue'),
    meta: {
      title: 'Assessment | MELO'
    }
  },

  {
    path: '/assessment-result',
    name: 'assessment-result',
    component: () => import(/* webpackChunkName: "about" */ '@/views/newViews/AssessmentResultNew.vue'),
    meta: {
      title: 'Assessment Result | MELO'
    }
  },
  {
    path: '/data',
    name: 'data',
    component: () => import(/* webpackChunkName: "about" */ '@/views/SearchPage.vue'),
    meta: {
      title: 'Search | MELO'
    }
  },
  {
    path: '/search-protein-by-seq',
    name: 'search-protein-by-seq',
    component: () => import(/* webpackChunkName: "about" */ '@/views/SearchResultProteinSeq.vue'),
    meta: { 
      title: 'Protein Sequence Similarity Results | MELO'
    }
  },
  {
    path: '/search-protein',
    name: 'search-protein',
    component: () => import(/* webpackChunkName: "about" */ '@/views/SearchResultProtein.vue'),
    meta: { 
      title: 'Protein Search Results | MELO'
    }
  },
  {
    path: '/download',
    name: 'download',
    component: () => import(/* webpackChunkName: "about" */ '@/views/DownloadPage.vue'),
    meta: {
      title: 'Full Data Download | MELO'
    }
  },
  {
    path: '/manual',
    name: 'manual',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ManualPage.vue'),
    meta: {
      title: 'Manual | MELO'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ContactView.vue'),
    meta: {
      title: 'Contact US | MELO'
    }
  },


  {
    path: '/to-be-available',
    name: 'to-be-available',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ToBeAvailable.vue'),
    meta: {
      title: 'To be available | MELO'
    }
  },



]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
